module.exports = __webpack_public_path__ + "static/img/國文師資介紹.9391c4a4.png";